import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import ChildPage from './pages/ChildPage'
import OutroPage from './pages/OutroPage'
import PageNotFound from './pages/PageNotFound'
import { AnimatePresence } from 'framer-motion'

function App() {
  const location = useLocation()

  return (
    <AnimatePresence>
      <Routes key={location.pathname} location={location}>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/:category/:index' element={<ChildPage />} />
        <Route exact path='/outro' element={<OutroPage />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </AnimatePresence>
  )
}

export default App
